import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const FormInput = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    className={cx('text-white bg-gray-dark w-full inline-block rounded-md p-3 h-48', className)}
    ref={ref}
    {...props}
  />
));

FormInput.propTypes = {
  className: PropTypes.string,
};

FormInput.defaultProps = {
  className: '',
};

export default FormInput;
